/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { PodRequest } from "../models/pod-request";
import { PodJobEx } from "../models/pod-job-ex";
import { PodLayoutEx } from "../models/pod-layout-ex";
import { UpdateSharingStatus } from "../models/update-sharing-status";
import { EditPodRecurringRequest } from "../models/edit-pod-recurring-request";
@Injectable({
  providedIn: "root",
})
class PrintOnDemandService extends __BaseService {
  static readonly printOnDemandPrintOnDemandPath =
    "/api/PrintOnDemand/PrintOnDemand";
  static readonly printOnDemandGetPrintOnDemandStatusPath =
    "/api/PrintOnDemand/GetPrintOnDemandStatus/{printOnDemandId}";
  static readonly printOnDemandCreatePrintOnDemandLayoutPath =
    "/api/PrintOnDemand/CreatePrintOnDemandLayout";
  static readonly printOnDemandUpdatePrintOnDemandLayoutPath =
    "/api/PrintOnDemand/UpdatePrintOnDemandLayout/{printOnDemandLayoutId}";
  static readonly printOnDemandDeletePrintOnDemandLayoutPath =
    "/api/PrintOnDemand/DeletePrintOnDemandLayout/{printOnDemandLayoutId}";
  static readonly printOnDemandUpdatePodLayoutSharingPath =
    "/api/PrintOnDemand/UpdatePodLayoutSharing";
  static readonly printOnDemandCreateRecurringPodPath =
    "/api/PrintOnDemand/CreateRecurringPod";
  static readonly printOnDemandUpdateRecurringPodPath =
    "/api/PrintOnDemand/UpdateRecurringPod/{podRecurringId}";
  static readonly printOnDemandDeleteRecurringPodPath =
    "/api/PrintOnDemand/DeleteRecurringPod/{podRecurringId}";
  static readonly printOnDemandExecuteRecurringPodNowPath =
    "/api/PrintOnDemand/ExecuteRecurringPodNow/{podRecurringId}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param podRequest undefined
   */
  printOnDemandPrintOnDemandResponse(
    podRequest: PodRequest
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = podRequest;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PrintOnDemand/PrintOnDemand`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param podRequest undefined
   */
  printOnDemandPrintOnDemand(podRequest: PodRequest): __Observable<number> {
    return this.printOnDemandPrintOnDemandResponse(podRequest).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param printOnDemandId undefined
   */
  printOnDemandGetPrintOnDemandStatusResponse(
    printOnDemandId: number
  ): __Observable<__StrictHttpResponse<PodJobEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/PrintOnDemand/GetPrintOnDemandStatus/${printOnDemandId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PodJobEx>;
      })
    );
  }
  /**
   * @param printOnDemandId undefined
   */
  printOnDemandGetPrintOnDemandStatus(
    printOnDemandId: number
  ): __Observable<PodJobEx> {
    return this.printOnDemandGetPrintOnDemandStatusResponse(
      printOnDemandId
    ).pipe(__map((_r) => _r.body as PodJobEx));
  }

  /**
   * @param request undefined
   */
  printOnDemandCreatePrintOnDemandLayoutResponse(
    request: PodLayoutEx
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PrintOnDemand/CreatePrintOnDemandLayout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param request undefined
   */
  printOnDemandCreatePrintOnDemandLayout(
    request: PodLayoutEx
  ): __Observable<number> {
    return this.printOnDemandCreatePrintOnDemandLayoutResponse(request).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `PrintOnDemandService.PrintOnDemandUpdatePrintOnDemandLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `printOnDemandLayoutId`:
   */
  printOnDemandUpdatePrintOnDemandLayoutResponse(
    params: PrintOnDemandService.PrintOnDemandUpdatePrintOnDemandLayoutParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/PrintOnDemand/UpdatePrintOnDemandLayout/${params.printOnDemandLayoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `PrintOnDemandService.PrintOnDemandUpdatePrintOnDemandLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `printOnDemandLayoutId`:
   */
  printOnDemandUpdatePrintOnDemandLayout(
    params: PrintOnDemandService.PrintOnDemandUpdatePrintOnDemandLayoutParams
  ): __Observable<number> {
    return this.printOnDemandUpdatePrintOnDemandLayoutResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param printOnDemandLayoutId undefined
   */
  printOnDemandDeletePrintOnDemandLayoutResponse(
    printOnDemandLayoutId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/PrintOnDemand/DeletePrintOnDemandLayout/${printOnDemandLayoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param printOnDemandLayoutId undefined
   */
  printOnDemandDeletePrintOnDemandLayout(
    printOnDemandLayoutId: number
  ): __Observable<Blob> {
    return this.printOnDemandDeletePrintOnDemandLayoutResponse(
      printOnDemandLayoutId
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param params The `PrintOnDemandService.PrintOnDemandUpdatePodLayoutSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `podLayoutId`:
   */
  printOnDemandUpdatePodLayoutSharingResponse(
    params: PrintOnDemandService.PrintOnDemandUpdatePodLayoutSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.podLayoutId != null)
      __params = __params.set("podLayoutId", params.podLayoutId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PrintOnDemand/UpdatePodLayoutSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `PrintOnDemandService.PrintOnDemandUpdatePodLayoutSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `podLayoutId`:
   */
  printOnDemandUpdatePodLayoutSharing(
    params: PrintOnDemandService.PrintOnDemandUpdatePodLayoutSharingParams
  ): __Observable<boolean> {
    return this.printOnDemandUpdatePodLayoutSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param request undefined
   */
  printOnDemandCreateRecurringPodResponse(
    request: EditPodRecurringRequest
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PrintOnDemand/CreateRecurringPod`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param request undefined
   */
  printOnDemandCreateRecurringPod(
    request: EditPodRecurringRequest
  ): __Observable<number> {
    return this.printOnDemandCreateRecurringPodResponse(request).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `PrintOnDemandService.PrintOnDemandUpdateRecurringPodParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `podRecurringId`:
   */
  printOnDemandUpdateRecurringPodResponse(
    params: PrintOnDemandService.PrintOnDemandUpdateRecurringPodParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/PrintOnDemand/UpdateRecurringPod/${params.podRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `PrintOnDemandService.PrintOnDemandUpdateRecurringPodParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `podRecurringId`:
   */
  printOnDemandUpdateRecurringPod(
    params: PrintOnDemandService.PrintOnDemandUpdateRecurringPodParams
  ): __Observable<number> {
    return this.printOnDemandUpdateRecurringPodResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param podRecurringId undefined
   */
  printOnDemandDeleteRecurringPodResponse(
    podRecurringId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PrintOnDemand/DeleteRecurringPod/${podRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param podRecurringId undefined
   */
  printOnDemandDeleteRecurringPod(podRecurringId: number): __Observable<Blob> {
    return this.printOnDemandDeleteRecurringPodResponse(podRecurringId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param podRecurringId undefined
   */
  printOnDemandExecuteRecurringPodNowResponse(
    podRecurringId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/PrintOnDemand/ExecuteRecurringPodNow/${podRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param podRecurringId undefined
   */
  printOnDemandExecuteRecurringPodNow(
    podRecurringId: number
  ): __Observable<Blob> {
    return this.printOnDemandExecuteRecurringPodNowResponse(
      podRecurringId
    ).pipe(__map((_r) => _r.body as Blob));
  }
}

module PrintOnDemandService {
  /**
   * Parameters for PrintOnDemandUpdatePrintOnDemandLayout
   */
  export interface PrintOnDemandUpdatePrintOnDemandLayoutParams {
    request: PodLayoutEx;
    printOnDemandLayoutId: number;
  }

  /**
   * Parameters for PrintOnDemandUpdatePodLayoutSharing
   */
  export interface PrintOnDemandUpdatePodLayoutSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    podLayoutId?: number;
  }

  /**
   * Parameters for PrintOnDemandUpdateRecurringPod
   */
  export interface PrintOnDemandUpdateRecurringPodParams {
    request: EditPodRecurringRequest;
    podRecurringId: number;
  }
}

export { PrintOnDemandService };
